import * as React from "react";
import * as _ from "lodash";
import { DrawerListItem, DrawerItemLabel } from './styles';
import { SearchableDropdownItem } from './constants';
import { SearchedField } from '../SearchBox/SearchField';

export interface FilterSuggestDrawerProps {
    option: SearchableDropdownItem
    searchTerm?: string
    focused: boolean

    onOptionSelected: (SearchableDropdownItem) => void
}
export interface FilterSuggestDrawerState { }

export class FilterSuggestDrawerItem extends React.Component<FilterSuggestDrawerProps, FilterSuggestDrawerState> {
    constructor(props: FilterSuggestDrawerProps) {
        super(props);
    }

    onItemSelected = (e) => {
        if (!(e && e.isDefaultPrevented())) {
            this.props.onOptionSelected(this.props.option);
        }
    }

    onItemCheckboxSelected = (e) => {
        e.preventDefault();
        this.props.onOptionSelected(this.props.option);
    }

    render() {
        return (
            <DrawerListItem
                onClick={this.onItemSelected}
                highlighted={this.props.focused}
            >
                <DrawerItemLabel>
                    <SearchedField
                        field={this.props.option.displayName}
                        searchTerm={this.props.searchTerm ? this.props.searchTerm : ""}
                        ignoreCase={true}
                    />
                </DrawerItemLabel>

            </DrawerListItem>
        );
    }
}
